import styled from 'styled-components';
import MuiButtonGroup from '@mui/material/ButtonGroup';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
`;

export const ButtonGroup2 = styled(MuiButtonGroup)`
  &.MuiButtonGroup-root {
    box-shadow: none;
    border-radius: 0;

    .MuiButtonBase-root {
      margin-left: 0.75rem;
      color: #fff;
      background: #791ace;
      border: 0 !important;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      border-radius: 8px !important;

      &.active,
      &:hover {
        opacity: 0.5;
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
          0px 2px 2px 0px rgba(0, 0, 0, 0.14),
          0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      }
    }
  }
`;
export const ButtonGroup = styled(MuiButtonGroup)`
  &.MuiButtonGroup-root {
    box-shadow: none;
    border-radius: 0;

    .MuiButtonBase-root {
      margin-left: 5px;
      color: #791ace;
      background: transparent;
      border: 0 !important;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      border-radius: 8px !important;

      &.active,
      &:hover {
        color: #fff;
        background: #791ace;
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
          0px 2px 2px 0px rgba(0, 0, 0, 0.14),
          0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      }
    }
    &.company-page {
      .MuiButtonBase-root {
        margin-left: 0.75rem;
        color: #fff;
        background: #791ace;
        border: 0 !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border-radius: 8px !important;

        &.active,
        &:hover {
          opacity: 0.5;
          box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
            0px 2px 2px 0px rgba(0, 0, 0, 0.14),
            0px 1px 5px 0px rgba(0, 0, 0, 0.12);
        }
      }
    }
  }
`;
